import { CSSProperties } from "react";

export const AutoSliderStyles = (
  slidesCount: number,
  index: number,
  width: number,
  height: number,
  radius: number,
  objectFit: "contain" | "cover",
  responsive: boolean,
  isRTL = false   // ← add this
) => {
  const aspect = `${width} / ${height}`;

  const wrap: CSSProperties = responsive
    ? {
        position: "relative",
        width: "100%",
        maxWidth: width,
        aspectRatio: aspect,
        borderRadius: radius,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,.12)",
        boxShadow: "0 10px 30px rgba(0,0,0,.12)",
      }
    : {
        position: "relative",
        width,
        height,
        borderRadius: radius,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,.12)",
        boxShadow: "0 10px 30px rgba(0,0,0,.12)",
      };

  const offset = index * (100 / slidesCount);

  const track: CSSProperties = {
    display: "flex",
    width: `${slidesCount * 100}%`,
    height: "100%",
    transform: isRTL
      ? `translateX(${offset}%)`   // ← positive in RTL
      : `translateX(-${offset}%)`,
    transition: "transform .45s ease",
  };

  const slide: CSSProperties = {
    width: `${100 / slidesCount}%`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,.04)",
  };

  const imgStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    objectFit,
    display: "block",
  };

  const arrowBtn: CSSProperties = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: 36,
    height: 36,
    borderRadius: 10,
    border: "none",
    background: "rgba(255,255,255,.85)",
    color: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 8px 22px rgba(0,0,0,.16)",
    userSelect: "none",
    touchAction: "manipulation",
  };

  const dotsWrap: CSSProperties = {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 8,
    display: "flex",
    gap: 6,
    justifyContent: "center",
    alignItems: "center",
  };

  const dot = (active: boolean): CSSProperties => ({
    width: 8,
    height: 8,
    borderRadius: 999,
    background: active ? "var(--accent,#6c5ce7)" : "rgba(0,0,0,.25)",
    transform: active ? "scale(1.15)" : "scale(1)",
    cursor: "pointer",
    transition: "transform .2s ease, background-color .2s ease",
  });

  return { wrap, track, slide, imgStyle, arrowBtn, dotsWrap, dot };
};